import { createSlice } from "@reduxjs/toolkit";
import * as CategoryApi from "../api/category";
const categories = createSlice({
  name: "categories",
  initialState: {
    loading: false,
    error: null,
    list: [],
    summary: null,
  },
  reducers: {
    setLoading: (state) => {
      state.error = null;
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getListSuccess: (state, action) => {
      state.list = action.payload.docs;
      state.summary = action.payload.summary;
      state.loading = false;
    },
    addCategorySuccess: (state, action) => {
      state.list = [...state.list, action.payload];
    },
    updateCategorySuccess: (state, action) => {
      state.list = state.list.map((category) => {
        if (category._id === action.payload._id) {
          return action.payload;
        } else {
          return category;
        }
      });
    },
    deleteCategorySuccess: (state, action) => {
      state.list = state.list.filter(
        (item) => action.payload?._id !== item._id
      );
    },
  },
});

export const getListCategory = (params) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await CategoryApi.getListCategory(params);
    dispatch(getListSuccess(res));
  } catch (error) {
    dispatch(setError(error));
  }
};

const { reducer, actions } = categories;
export const {
  setLoading,
  setError,
  getListSuccess,
  addCategorySuccess,
  deleteCategorySuccess,
  updateCategorySuccess,
} = actions;
export default reducer;
